import '../css/main.scss';
import Player from "./Core/Player/Player";
import HomePlayList from "./Modules/HomePlayList";

let authModal = document.getElementById('auth-modal');
let authModalOpenBtn = document.getElementById('open-auth-modal');
let authModalCloseBtn = document.getElementById('close-auth-modal');

authModalOpenBtn.addEventListener('click', () => {
    authModal.classList.add('auth-modal--open');
});

authModalCloseBtn.addEventListener('click', () => {
    authModal.classList.remove('auth-modal--open');
});

new Player();

// new HomePlayList();